/**
 * Gedeelde tekst-normalisatie voor zoeken en slugs.
 *
 * Eén bron van waarheid zodat het build-script (dat slugs bakt) en de client-side
 * zoek-island (dat matcht) gegarandeerd hetzelfde doen. Pure functies, makkelijk
 * te unit-testen (§12).
 */

/** Vouwt diacrieten weg: "Súdwest-Fryslân" → "sudwest-fryslan". */
export function foldDiacritics(input: string): string {
  // NFD splitst basisletter en combining marks; \p{Diacritic} verwijdert de marks.
  return input.normalize('NFD').replace(/\p{Diacritic}/gu, '');
}

/**
 * Normaliseert vrije zoekinvoer: lowercase, diacriet-loos, leestekens → spatie,
 * spaties samengevouwen. Case- en diacritisch-ongevoelig matchen (§4).
 * Bv. "'s-Hertogenbosch" → "s hertogenbosch".
 */
export function normalizeForSearch(input: string): string {
  return foldDiacritics(input)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}

/**
 * Maakt een URL-slug: diacriet-loos, lowercase, niet-alfanumeriek → koppelteken.
 * Bv. "'s-Hertogenbosch" → "s-hertogenbosch", "Alphen aan den Rijn" → "alphen-aan-den-rijn".
 */
export function slugify(name: string): string {
  return foldDiacritics(name)
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
